module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-filter-small col-xs-12"
  }, [_c('div', {
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon info-icon-text"
  }), _c('span', {
    staticClass: "info-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.titulos.criteriosConciliacao.linkCamposConcil'))
    }
  })])]), _c('div', {
    staticClass: "col-xs-11"
  }, [_c('div', {
    staticClass: "col-xs-11",
    staticStyle: {
      "padding-left": "7px",
      "padding-roght": "7px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'mfField' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.movFinan'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mfFieldList,
      "label": "nome",
      "id": 'mfField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'mfField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.conciliacaoCampoMovFinan",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMfField
    },
    model: {
      value: (_vm.field.conciliacaoCampoMovFinan),
      callback: function($$v) {
        _vm.$set(_vm.field, "conciliacaoCampoMovFinan", $$v)
      },
      expression: "field.conciliacaoCampoMovFinan"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), (_vm.errors.firstByRule('field.conciliacaoCampoMovFinan', 'required')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()], 1), (_vm.field.conciliacaoCampoMovFinan && _vm.field.conciliacaoCampoMovFinan.tipo === 'A') ? _c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'attributeCfgMf' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.conjuntoAtributo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mfCfgList,
      "label": "attibuteSetName",
      "id": 'attributeCfgMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'attributeCfgMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.atributo.atributoCfg",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMfAttCfg
    },
    model: {
      value: (_vm.field.atributo.atributoCfg),
      callback: function($$v) {
        _vm.$set(_vm.field.atributo, "atributoCfg", $$v)
      },
      expression: "field.atributo.atributoCfg"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('field.atributo.atributoCfg', 'required')),
      expression: "errors.firstByRule('field.atributo.atributoCfg', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1) : _vm._e(), (_vm.field.conciliacaoCampoMovFinan && _vm.field.conciliacaoCampoMovFinan.tipo === 'A') ? _c('div', {
    staticClass: "col-xs-3"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'attributeMf' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.atributo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mfAttList,
      "label": "attibuteSetName",
      "id": 'attributeMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'attributeMf' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.atributo.nomeAtributo",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMfAtt
    },
    model: {
      value: (_vm.field.atributo.nomeAtributo),
      callback: function($$v) {
        _vm.$set(_vm.field.atributo, "nomeAtributo", $$v)
      },
      expression: "field.atributo.nomeAtributo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), (_vm.errors.firstByRule('field.atributo.nomeAtributo', 'required')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()], 1) : _vm._e()]), _c('div', {
    staticClass: "col-xs-11",
    staticStyle: {
      "padding-left": "7px",
      "padding-roght": "7px"
    }
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": 'mbField' + (_vm.field.key ? _vm.field.key : _vm.field.id)
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('planoConciliacao.labels.movBan'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true
    },
    attrs: {
      "options": _vm.mbFieldList,
      "label": "nome",
      "id": 'mbField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "name": 'mbField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "data-vv-name": "field.conciliacaoCampoMovBancario",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.changeMbField
    },
    model: {
      value: (_vm.field.conciliacaoCampoMovBancario),
      callback: function($$v) {
        _vm.$set(_vm.field, "conciliacaoCampoMovBancario", $$v)
      },
      expression: "field.conciliacaoCampoMovBancario"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), (_vm.errors.firstByRule('field.conciliacaoCampoMovBancario', 'required')) ? _c('span', {
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  }) : _vm._e()], 1)])]), _c('div', {
    staticClass: "col-xs-1",
    staticStyle: {
      "height": "10vh"
    }
  }, [_c('button-primary', {
    staticClass: "marged-button",
    staticStyle: {
      "border-radius": "50%",
      "border": "none",
      "margin": "6vh 10px 10px 0",
      "font-size": "30px"
    },
    attrs: {
      "title": _vm.$t('planoConciliacao.labels.remover'),
      "faIcon": "fa fa-times-circle",
      "id": 'btnRemoveField' + (_vm.field.key ? _vm.field.key : _vm.field.id),
      "clickFunction": _vm.removeField,
      "customClass": "secondary",
      "disabled": _vm.disabled
    }
  })], 1), _c('br'), _c('br')])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4ab25a9f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ab25a9f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/conciliationCriteria/conciliationCritFields.pug
// module id = 1411
// module chunks = 0